import api from "../services/api";

// Interest Category
export const addInterestCategory = (data) => {
    return api.post('admin/interest/add_category', data);
}

export const updateInterestCategory = (data) => {
    return api.put('admin/interest/update_category', data);
}

export const updateInterestCategoryStatus = (data) => {
    return api.put('admin/interest/update_category_status', data);
}

export const deleteInterestCategory = (id) => {
    return api.delete('admin/interest/delete_category', {
        data: { _id: id }
    });
}

export const getInterestCategories = (queryParams) => {
    return api.get(`admin/interest/category_list${queryParams}`);
};

// Interest Sub Categories
export const createInterestSubCategory = (data) => {
    return api.post('admin/interest/add_sub_category', data);
}

export const updateInterestSubCategory = (data) => {
    return api.put('admin/interest/update_sub_category', data);
}

export const updateInterestSubCategoryStatus = (data) => {
    return api.put('admin/interest/update_sub_category_status', data);
}

export const deleteInterestSubCategory = (id) => {
    return api.delete('admin/interest/delete_sub_category', {
        data: { _id: id }
    });
}

export const getInterestSubCategories = (queryParams) => {
    return api.get(`admin/interest/sub_category_list${queryParams}`);
};